<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M16 32l-7.245-8.755-8.755-7.245 8.755-7.321 7.245-8.679 7.245 8.679 8.755 7.321-8.755 7.245zM9.811 16l3.396 2.792 2.792 3.396 2.792-3.396 3.396-2.792-3.396-2.868-2.792-3.321-2.792 3.321z">
    </path>
  </svg>
</template>
